import { Outlet, createFileRoute } from "@tanstack/react-router";

import { PERMISSIONS } from "@/constants/permissions";
import { APP_ROUTES_FULL, APP_ROUTES_TO } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_FULL.DEVELOPER)({
    component: DeveloperLayout,
    staticData: {
        config: {
            title: "developer",
            breadcrumb: {
                title: "developer",
                to: APP_ROUTES_TO.DEVELOPER,
            },
        },
        permissions: [PERMISSIONS.CALL_SVC_ADMIN_BASE],
    },
});

function DeveloperLayout() {
    return <Outlet />;
}
